import { svg } from "config/svgStyles";

export const contentContainer = {
  width: "100%",
  padding: "40px",
  display: "flex",
  flexDirection: "column",
  zIndex: 100,
  flex: "50%",
};
export const modalImageContainer = {
  width: "100%",
  flex: "50%",
};

export const gearSelectorContainer = {
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  alignItems: "center",
  marginBottom: "20px",
  paddingBottom: "20px",
  borderBottom: "solid 1px",
  borderColor: "grey9",
  height: "270px",
  boxSizing: "border-box",
};

export const gearItemOption = ({ isSelected }) => ({
  background: isSelected ? "primary" : "none",
  color: isSelected ? "white" : "black",
  border: "solid 1px",
  borderColor: isSelected ? "white" : "grey5",
  borderRadius: "20px",

  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  height: "70px",
  padding: "10px 20px",

  "&:hover": {
    borderColor: isSelected ? "grey5" : "primary",
  },

  transition: "background-color 0.3s, border-color 0.3s",
});

export const iconAndText = {
  display: "flex",
  flexDirection: "row",
  gap: "20px",
  alignItems: "center",
};

export const checkbox = ({ isSelected }) => ({
  height: "30px",
  width: "30px",
  border: "solid 1px",
  background: "white",
  borderColor: isSelected ? "primary" : "grey5",
  borderRadius: "2px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  svg: {
    ...svg("primary"),
  },
});

export const modalTitle = {
  textTransform: "uppercase",
  paddingBottom: "20px",
  borderBottom: "solid 4px",
  borderColor: "grey9",
  marginBottom: "20px",
  lineHeight: "30px",
};

export const dropdownContainer = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "4px",
};

export const toggleSwitchContainer = {
  display: "flex",
  flexDirection: "row",
  gap: "20px",
  alignItems: "center",
};

export const toggleSwitch = ({ isDisabled }) => ({
  cursor: !isDisabled ? "pointer" : "not-allowed",
  height: "40px",
  width: "70px",
  background: "none",
  border: "1px solid",
  borderColor: "grey5",
  borderRadius: "20px",
  position: "relative",

  "&:hover ": {
    borderColor: !isDisabled ? "primary" : "grey5",
  },

  ".thumb": {
    position: "absolute",
    left: "5px",
    // 4px instead of 5 because of border 1px
    bottom: "4px",
    width: "30px",
    height: "30px",
    borderRadius: "10000px",
    background: !isDisabled ? "primary" : "grey5",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    svg: {
      ...svg("white"),
    },

    transition: "left 0.3s",
  },
});

export const handText = ({ isDisabled }) => ({
  width: "75px",
  textAlign: "center",
  whiteSpace: "nowrap",
  color: isDisabled ? "grey5" : "black",
});

export const toggleAndSubmitContainer = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "20px",
};
